export let Translation;

(function (Translation) {
  Translation["Auto"] = "auto";
  Translation["Manual"] = "manual";
  Translation["None"] = "none";
})(Translation || (Translation = {}));